import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {CoreCommonModule} from '@core/common.module';

import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {LoginComponent} from './login/login.component';
import { CompanyLoginComponent } from './company-login/company-login.component';
import {FullRegisterComponent} from './full-register/full-register.component';
import {RegisterComponent} from './register/register.component';
import {TranslateModule} from '@ngx-translate/core';
import { CustomRegisterComponent } from './custom-register/custom-register.component';
import { LoginRedirectSSOComponent } from './login-redirect-sso/login-redirect-sso.component';
import {SharedModule} from '../../shared/shared.module';
import { SignupComponent } from './signup/signup.component';
import {NgSelectModule} from "@ng-select/ng-select";
import { LoginOtpCodeComponent } from './login-otp-code/login-otp-code.component';

// routing
const routes: Routes = [

];

@NgModule({
  declarations: [
    CompanyLoginComponent,
    LoginComponent,
    LoginRedirectSSOComponent,
    FullRegisterComponent,
    ResetPasswordComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    CustomRegisterComponent,
    SignupComponent,
    LoginOtpCodeComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    CoreCommonModule,
    TranslateModule,
    SharedModule,
    NgSelectModule
  ]
})
export class AuthenticationModule {
}
